// The latest `run.status` frame for a run, from a `runs` subscription on the device socket.
import { useEffect, useState } from "react";

import { bytesEqual } from "../../proto/bytes";
import type { RunStatus } from "../../proto/frames";
import { ulidToBytes } from "../../proto/ulid";
import type { RelayClient } from "../../relay/client";

export function useRunStatus(relay: RelayClient | undefined, runId: string): RunStatus | undefined {
  const [status, setStatus] = useState<RunStatus>();
  useEffect(() => {
    if (!relay || runId === "") return;
    const id = ulidToBytes(runId);
    const off = relay.onFrame((frame) => {
      if (frame.type === "run.status" && bytesEqual(frame.run_id, id)) {
        const { type: _type, ...rest } = frame;
        setStatus(rest);
      }
    });
    const unsubscribe = relay.subscribe({ runs: [id] });
    relay.connect();
    return () => {
      off();
      unsubscribe();
    };
  }, [relay, runId]);
  return status;
}
